import axios from 'axios'

const Api = axios.create({
  baseURL: process.env.VUE_APP_API || window.location.protocol + '//' + window.location.host,
  transformRequest: (data, headers) => {
    headers['authorization'] = localStorage.getItem('authorization')
    return JSON.stringify(data)
  },
  validateStatus: (status: number) => {
    if (status === 401) {
      localStorage.removeItem('authorization')
      setTimeout(() => {
        // @ts-ignore
        window.location.replace(`http://${window.location.host}/login`)
      }, 500)
    }
    return status < 400
  },
  headers: {
    'Content-Type': 'application/json',
  },
})

const LogControl = {
  indexes: () => Api.get('/log-control/indexes'),
  update: (
    index: string,
    { active, time }: { active: boolean; time: string }
  ) => Api.put(`/log-control/${index}`, { active, time }),
  index: (index: string) => Api.get(`/log-control/${index}`),
  clearByDate: (index: string, lessThen: string) =>
    Api.delete(`/log-control/${index}?lt=${lessThen}`),
}
const LogAudit = {
  datatable: (params: object) => Api.post(`/log-audit/datatable`, params),
  tagEvents: () => Api.get(`/log-audit/tag-event/list`),
  getById: (logid: string) => Api.get(`/log-audit/${logid}`),
  indexFilters: (index: string) => Api.get(`/log-audit/filters/${index}`),
}
const LogCheck = {
  list: () => Api.get('/log-check/list'),
  add: ({
    name,
    url,
    slackbot = '',
    active = true,
  }: {
    name: string
    url: string
    slackbot: string
    active: boolean
  }) =>
    Api.post('/log-check', {
      name,
      url,
      slackbot,
      active,
    }),
  update: (
    id: string,
    {
      name,
      url,
      slackbot = '',
      active = false,
    }: {
      name: string
      url: string
      slackbot: string
      active: boolean
    }
  ) =>
    Api.put(`/log-check/${id}`, {
      name,
      url,
      slackbot,
      active,
    }),
  delete: (id: string) => Api.delete(`/log-check/${id}`),
}
const logElastic = {
  list: () => Api.get('/log-elastic'),
  updateSettings: (
    index: string,
    { readonly, limitFields }: { readonly: boolean; limitFields?: number }
  ) =>
    Api.put(`/log-elastic/${index}/settings`, {
      readonly,
      limitFields,
    }),
}
const Login = (password: string) => Api.post('/log-login', { password })

Api.prototype.LogControl = LogControl
Api.prototype.LogAudit = LogAudit
Api.prototype.LogCheck = LogCheck
Api.prototype.LogElastic = logElastic
Api.prototype.Login = Login

export default Api
export { Api, LogControl, LogAudit, LogCheck, logElastic, Login }
